import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-fsw-status',
  templateUrl: './update-fsw-status.component.html',
  styleUrls: ['./update-fsw-status.component.scss']
})
export class UpdateFswStatusComponent implements OnInit {
  p: number = 1;
  itemsPerPage: number = 10;
  isReadMode = false;
  addFSWForm!: FormGroup;
  StateRecord: any[] | undefined;
  fswStatusData: any[] | undefined;
  stateCode: any;
  selectedState: any;
  role: any;
  submitted = false;
  id:any;


  constructor(private formBuilder: FormBuilder, private fswService: FswService, private route: ActivatedRoute, private spinnerService: NgxSpinnerService, private toastr: ToastrService, private authService: AuthService) { }
  
  get f(): { [key: string]: AbstractControl } {
    return this.addFSWForm.controls;
  }

  ngOnInit(): void {
    this.addFSWForm = this.formBuilder.group({
      stateCode: ['', Validators.required],
      totalFswAlloted: ['',[Validators.required, Validators.pattern("^[0-9]*$")]],
      totalFswRunning: ['',[Validators.required, Validators.pattern("^[0-9]*$")]],
      id: ['']
    })
    this.route.params.subscribe(params => {
      debugger
      this.stateCode = params['stateCode']; 
      
    });
    this.role = this.authService.getRole();
    // if (this.role == 'ADMIN') {
    //   this.stateCode = 'ALL'
    //   this.bindfswstatuslist(this.stateCode);
    // }
    // else
    // {
    //   this.bindfswstatuslist(this.stateCode);
    // }
    this.getState();
    this.bindfswstatuslist(this.stateCode);
    this.selectedState = this.stateCode;

    
  }

  bindfswstatuslist(stateCode) {
    debugger
    this.spinnerService.show();
    this.fswService.getfswstatuslist(stateCode).subscribe((data: any[]) => {
      this.fswStatusData = data;
      this.spinnerService.hide();

        // this.id = data[0].id;
        // this.selectedState = data[0].stateCode;
        this.addFSWForm.controls['id'].setValue(data[0].id);
        this.addFSWForm.controls['totalFswAlloted'].setValue(data[0].totalFswAlloted);
        this.addFSWForm.controls['totalFswRunning'].setValue(data[0].totalFswRunning);
        this.addFSWForm.controls['stateCode'].setValue(data[0].stateCode);
        this.selectedState=data[0].stateName;

      error => {
        debugger
        console.log(error);
        this.toastr.error('Some Error Occured!');
        this.spinnerService.hide();
      }
    })
  }
  createRow() {
    this.isReadMode = false;
    this.getState();
  }
  getState() {
    debugger
    this.spinnerService.show();
    this.fswService.getState().subscribe(
      (Statedata) => {
        this.StateRecord = Statedata;
        console.log(this.StateRecord);
        this.spinnerService.hide();
      }
    )
  }
  onsaveFsw() {
    debugger
    this.spinnerService.show();
    var totalFsw: number =  Number(this.addFSWForm.value.totalFswAlloted);
    var totalFswRunning: number  =  Number(this.addFSWForm.value.totalFswRunning);
    if(totalFswRunning > totalFsw)
    {
      debugger
      this.toastr.error('Total FSW Running should be less than Total FSW Alloted');
      this.spinnerService.hide();
      return;
      
    }
    debugger
    if (this.addFSWForm.invalid) {
      return;
    }
    console.log(this.addFSWForm.value);
    this.fswService.saveFSWStateStatus(this.addFSWForm.value)
      .subscribe(
        response => {
          debugger
          this.spinnerService.hide();
          this.addFSWForm.reset({});
         // this.isReadMode = true;
          this.toastr.success('FSW Status Data Saved Successfully!');
          this.bindfswstatuslist(this.stateCode);
        },
        error => {
          debugger
          console.log(error);
          this.toastr.error('Some Error Occured!');
          this.spinnerService.hide();
        });

  }

  backOption() {
    window.history.back();
  }
  showisReadMode() {
   // this.isReadMode = true;
  }
  updateRow(x: any) {

    debugger
    var updtBtn = confirm(" Do you want to update ?");
    if (updtBtn == true) {
      debugger
      if (x) {
        debugger
        this.spinnerService.show();
        this.isReadMode = false;
        this.getState();
        this.id = x.id;
        this.selectedState = x.stateCode;
        this.addFSWForm.controls['id'].setValue(x.id);
        this.addFSWForm.controls['totalFswAlloted'].setValue(x.totalFswAlloted);
        this.addFSWForm.controls['totalFswRunning'].setValue(x.totalFswRunning);
        this.addFSWForm.controls['stateCode'].setValue(x.stateCode);
        this.spinnerService.hide();
      }
      else {
        this.isReadMode = false;
      }
    }
  }


}
